import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AlertService} from '../../services/alert.service';

@Component({
  selector: 'app-alert-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.css'
})
export class AlertMessageComponent {
  @Input() message?: string | null = null;
  @Input() type?: 'error' | 'success' | 'info' | 'warning' = 'error';
  protected alertService: AlertService = inject(AlertService);

  close() {
    this.alertService.clear();
  }

  get alertClass(): string {
    switch (this.type) {
      case 'error':
        return 'alert-danger';
      case 'success':
        return 'alert-success';
      case 'info':
        return 'alert-info';
      case 'warning':
        return 'alert-warning';
      default:
        return 'alert-secondary';
    }
  }

  get iconClass(): string {
    switch (this.type) {
      case 'error':
        return 'bi bi-exclamation-triangle-fill';
      case 'success':
        return 'bi bi-check-circle-fill';
      case 'info':
        return 'bi bi-info-circle-fill';
      case 'warning':
        return 'bi bi-exclamation-circle-fill';
      default:
        return 'bi bi-info-circle';
    }
  }
}






